import { generateKey } from "../../../Utils/helpers";

const Select = (props: any) => {
    return (
        <select
            disabled={props.disabled}
            className={"form-select "+props.className}
            name={props.name}
            value={props.value}
            onChange={props.onChange}>
            {props.defaultLabel && <option className="d-none" value="">{props.defaultLabel}</option>}
            {props.items.map((row: any) => {
                return <option key={generateKey()} value={row[props.labelValue]}>{row[props.label]}</option>;
            })}
        </select>
    )   
}

export { Select };